import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faSearch,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import ReactPaginate from "react-paginate";
import { RequestListing } from "../../../../services/collegeRequests";
import { useNavigate } from "react-router-dom";

const CollegeRequests = () => {
  const [requests, setRequests] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limitPage, setLimitPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(0);

  const navigate = useNavigate();
  // Fetch college requests data
  const fetchCollegeRequests = async () => {
    setLoading(true);
    try {
      const response = await RequestListing({
        page: currentPage,
        limit: limitPage,
        search_key: searchTerm,
      });

      if (response && response.data && response.data.result) {
        setRequests(response.data.result);
        setTotalCount(response.data.total_count);

        // Calculate total pages
        const total = response.data.total_count;
        const totalPages = Math.ceil(total / limitPage);
        setPageCount(totalPages);
      }
    } catch (error) {
      console.error("Error fetching college requests:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCollegeRequests();
  }, [currentPage, limitPage, searchTerm]);

  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setCurrentPage(selectedPage + 1);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1); // Reset to first page when searching
    fetchCollegeRequests();
  };

  const handleViewDetails = (id) => {
    navigate(`/view-requests/${id}`);
  };
  // Function to determine status text and class
  const getStatusInfo = (status) => {
    switch (status) {
      case "0":
        return { text: "Rejected", className: "status-rejected" };
      case "1":
        return { text: "Accepted", className: "status-approved" };
      case "2":
        return { text: "Under verification", className: "status-pending" };
      case "3":
        return { text: "Incomplete profile", className: "status-incomplete" };
      default:
        return { text: "Unknown", className: "status-unknown" };
    }
  };

  // Format date to readable format
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div className="dashboard college-requests-list">
      <div className="subheader">
        <Row>
          <Col xs={12}>
            <div className="subheader-right-top">
              <Form onSubmit={handleSearch} className="subheader-search-form">
                <Form.Group controlId="formFile" className="subheader-search">
                  <Form.Control
                    type="search"
                    placeholder="Search requests..."
                    onChange={(e) => setSearchTerm(e.target.value)}
                    value={searchTerm}
                  />
                  {/* <Button type="submit" className="search-button search-icon"> */}

                  <FontAwesomeIcon icon={faSearch} className="search-icon" />
                  {/* </Button> */}
                </Form.Group>
              </Form>
            </div>
          </Col>
        </Row>
      </div>

      <div className="table-main fixTableHead">
        {!isLoading && (
          <table className="table nowrap table-bordered table-default-dark">
            <thead>
              <tr className="table-heading">
                <th>S.No</th>
                <th>College Name</th>
                <th>Admin Name</th>
                <th>Mobile No</th>
                <th>City</th>
                <th>Email</th>
                <th>Status</th>
                {/* <th>Created Date</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((request, index) => {
                const statusInfo = getStatusInfo(request.request_status);
                // Truncate college name to 20 characters
                const truncatedName =
                  request.clg_name.length > 20
                    ? request.clg_name.substring(0, 20) + "..."
                    : request.clg_name;

                return (
                  <tr key={request.request_id}>
                    <td>{(currentPage - 1) * limitPage + index + 1}</td>
                    <td title={request.clg_name}>{truncatedName}</td>
                    <td>{request.college_admin || "Not Assigned"}</td>
                    <td>
                      {request.country_code} {request.mobile_no}
                    </td>
                    <td>{request.city}</td>
                    <td>{request.official_email}</td>
                    <td>
                      <span className={statusInfo.className}>
                        {statusInfo.text}
                      </span>
                    </td>
                    {/* <td>{formatDate(request.created_at)}</td> */}
                    <td>
                      <Button
                        className="view-btn me-1"
                        onClick={() => handleViewDetails(request.request_id)}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        {isLoading && <div className="text-center py-4">Loading...</div>}
        {!isLoading && requests.length === 0 && (
          <div className="text-center py-4">No college requests found</div>
        )}
      </div>

      {pageCount > 1 && (
        <div className="pagination-container">
          <div className="pagination-info">
            Showing {requests.length} of {totalCount} entries
          </div>
          <ReactPaginate
            previousLabel={<FontAwesomeIcon icon={faAngleDoubleLeft} />}
            nextLabel={<FontAwesomeIcon icon={faAngleDoubleRight} />}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"pagination custom-pagination"}
            activeClassName={"active"}
            forcePage={currentPage - 1}
          />
        </div>
      )}
    </div>
  );
};

export default CollegeRequests;
